<script lang="ts">
  export let tag: "a" | "button";
  export let appearance: "blue" | "red" | "white";
  export let href: string = null;
</script>

<svelte:element this={tag} class="Button Button--{appearance}" {href}>
  <slot />
</svelte:element>

<style>
  .Button {
    border: var(--size-1) solid var(--color-white);
    border-radius: var(--size-20);
    color: var(--color-blue);
    font-weight: 600;
    padding-block: var(--size-8);
    padding-inline: var(--size-18);
    text-decoration: none;
  }

  .Button--blue {
    background: var(--color-blue);
  }

  .Button--red {
    background: var(--color-red);
  }

  .Button--white {
    background: var(--color-white);
  }
</style>
